"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormGS = void 0;
const gs = require("..");
const WrapperGS_js_1 = require("../core/WrapperGS.js");
const core_1 = require("../core");
class TextValueWrapper {
    constructor(wr) {
        this._wr = wr;
    }
    get value() {
        return this._wr.el.innerText;
    }
    set value(value) {
        this._wr.el.innerText = value + "";
    }
}
class FormGS extends WrapperGS_js_1.WrapperGS {
    constructor(el) {
        super(el);
        this._handlers = [];
        this._firstTimeValidated = false;
        this.addEventHandler();
    }
    static ForHTMLElement(el) { return el.nodeName.toLowerCase() === "form"; }
    static AddExternalValidation(name, func) { this._ExternalFunc.set(name, func); }
    validAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this.addEventHandler();
            const valids = yield gs.array.parallelAsync(this._handlers, (w) => this.validFieldAsync(w.wrapper));
            const valid = valids.filter(r => r === false).length === 0;
            return valid;
        });
    }
    fillFormData(data, withValidation = true) {
        return __awaiter(this, void 0, void 0, function* () {
            this.addEventHandler();
            for (const control of this._handlers) {
                const w = control.wrapper;
                const name = w.attr('name');
                if (!name)
                    continue;
                if (data[name] === undefined)
                    continue;
                const inputEl = gs.def.toType(w.el, HTMLInputElement);
                if (inputEl) {
                    if (inputEl.type === "radio") {
                        if (inputEl.value === gs.def.string(data[name]))
                            inputEl.checked = true;
                        continue;
                    }
                    if (inputEl.type === "checkbox") {
                        if (!Array.isArray(data[name]))
                            continue;
                        const array = [];
                        data[name].forEach(v => array.push(gs.def.string(v)));
                        if (!gs.array.contains(array, inputEl.value))
                            continue;
                        inputEl.checked = true;
                        continue;
                    }
                }
                const valuedWr = WrapperGS_js_1.WrapperGS.ToValued(w);
                if (valuedWr) {
                    valuedWr.value = data[name];
                    continue;
                }
                const valuedAsyncWr = WrapperGS_js_1.WrapperGS.ToAsyncValued(w);
                if (valuedAsyncWr) {
                    yield valuedAsyncWr.setValueAsync(data[name]);
                    continue;
                }
                const valuedText = new TextValueWrapper(w);
                if (valuedText) {
                    valuedText.value = data[name];
                    continue;
                }
            }
            if (withValidation)
                this.getFormData();
        });
    }
    getFormData(evenNotValid = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const valid = yield this.validAsync();
            if (!evenNotValid)
                if (!valid)
                    return undefined;
            const data = new Object();
            for (const control of this._handlers) {
                const w = control.wrapper;
                const name = w.attr('name');
                if (!name)
                    continue;
                const inputEl = gs.def.toType(w.el, HTMLInputElement);
                if (inputEl) {
                    switch (inputEl.type) {
                        case "radio":
                            if (inputEl.checked)
                                data[name] = inputEl.value;
                            continue;
                        case "checkbox":
                            if (!data[name]) {
                                data[name] = new Array(0);
                            }
                            if (!inputEl.checked)
                                continue;
                            data[name].push(inputEl.value);
                            continue;
                    }
                }
                const valuedWr = WrapperGS_js_1.WrapperGS.ToValued(w);
                if (valuedWr) {
                    data[name] = valuedWr.value;
                    continue;
                }
                const valuedAsyncWr = WrapperGS_js_1.WrapperGS.ToAsyncValued(w);
                if (valuedAsyncWr) {
                    data[name] = yield valuedAsyncWr.getValueAsync();
                    continue;
                }
                const valuedText = new TextValueWrapper(w);
                if (valuedText) {
                    data[name] = valuedText.value;
                    continue;
                }
            }
            return data;
        });
    }
    destroy() {
        this._handlers.forEach(h => h.dispose());
        gs.array.clear(this._handlers);
    }
    validFieldAsync(field) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!field)
                return undefined;
            if (!field.el.isConnected) {
                const handler = this._handlers.filter(c => c.wrapper === field)[0];
                if (!handler)
                    return undefined;
                handler.dispose();
                gs.array.remove(this._handlers, handler);
                return undefined;
            }
            //Proccessing firstTimeValidation
            if (!this._firstTimeValidated) {
                this._firstTimeValidated = true;
                yield this.validAsync();
            }
            const fieldSetElement = gs.def.toType(field.el, HTMLFieldSetElement);
            let formItem = field;
            while (true) {
                if (formItem.hasClass(FormGS.TagClassItemName))
                    break;
                if (!formItem.el.parentNode) {
                    formItem = undefined;
                    break;
                }
                formItem = gs.w(formItem.el.parentNode);
            }
            //Clear validation
            if (fieldSetElement)
                fieldSetElement.setCustomValidity('');
            if (formItem) {
                formItem.removeClass(FormGS.TagClassValid);
                formItem.removeClass(FormGS.TagClassInvalid);
            }
            const rulesArg = field.attr('validrules');
            if (!rulesArg)
                return true;
            const rules = rulesArg.split(' ');
            let validErrors = [];
            const addError = (error) => {
                if (typeof error === "string") {
                    validErrors.push(error);
                    return true;
                }
                return false;
            };
            for (const ruleRecord of rules) {
                let rule;
                let ruleArg;
                if (ruleRecord.indexOf("=") >= 0) {
                    const parser = ruleRecord.split("=");
                    rule = parser[0].toLowerCase();
                    ruleArg = parser[1];
                }
                else
                    rule = ruleRecord.toLowerCase();
                if (rule === 'external') {
                    if (!FormGS._ExternalFunc.has(ruleArg)) {
                        addError("Unknown function of validation");
                        continue;
                    }
                    const validationFunction = FormGS._ExternalFunc.get(ruleArg);
                    addError(validationFunction(field));
                    continue;
                }
                const validable = WrapperGS_js_1.WrapperGS.ToValidable(field);
                if (validable) {
                    addError(validable.valid(rule, ruleArg));
                    continue;
                }
                const validableAsync = WrapperGS_js_1.WrapperGS.ToAsyncValidable(field);
                if (validableAsync) {
                    addError(yield validableAsync.validAsync(rule, ruleArg));
                    continue;
                }
                let valued = WrapperGS_js_1.WrapperGS.ToValued(field);
                if (!valued)
                    valued = new TextValueWrapper(field);
                let anotherControl;
                let anotherValued;
                switch (rule) {
                    case 'req':
                        addError(gs.validation.valueRequired(valued));
                        break;
                    case 'number':
                    case 'numbers':
                        addError(gs.validation.valueIsNumber(valued));
                        break;
                    case 'max':
                        addError(gs.validation.valueNumberMax(valued, parseFloat(ruleArg)));
                        break;
                    case 'min':
                        addError(gs.validation.valueNumberMin(valued, parseFloat(ruleArg)));
                        break;
                    case 'uint':
                        addError(gs.validation.valueNumberUInt(valued));
                        break;
                    case 'int':
                        addError(gs.validation.valueNumberInt(valued));
                        break;
                    case 'notonlynumbers':
                        addError(gs.validation.valueNotNumber(valued));
                        break;
                    case 'length':
                        addError(gs.validation.valueLength(valued, parseInt(ruleArg)));
                        break;
                    case 'minlength':
                        addError(gs.validation.valueMinLength(valued, parseInt(ruleArg)));
                        break;
                    case 'maxlength':
                        addError(gs.validation.valueMaxLength(valued, parseInt(ruleArg)));
                        break;
                    case 'phone':
                        addError(gs.validation.valueIsPhone(valued));
                        break;
                    case 'email':
                        addError(gs.validation.valueIsEmail(valued));
                        break;
                    case 'same':
                        anotherControl = this._handlers.filter(i => i.wrapper.attr('name') === ruleArg)[0];
                        anotherValued = WrapperGS_js_1.WrapperGS.ToValued(anotherControl.wrapper);
                        if (!anotherValued)
                            addError(gs.validation.messages.notFoundSameField);
                        else
                            addError(gs.validation.valueSame(valued, anotherControl.wrapper));
                        break;
                    case 'samebyid':
                        anotherControl = this._handlers.filter(i => i.wrapper.attr('id') === ruleArg)[0];
                        anotherValued = WrapperGS_js_1.WrapperGS.ToValued(anotherControl.wrapper);
                        if (!anotherValued)
                            addError(gs.validation.messages.notFoundSameField);
                        else
                            addError(gs.validation.valueSame(valued, anotherControl.wrapper));
                        break;
                }
            }
            //Remove duplicate values
            validErrors = [...new Set(validErrors)];
            const errorsText = validErrors.join('\r\n');
            //Если есть встроенные возможности, используем
            let isValid = validErrors.length === 0;
            if (fieldSetElement)
                fieldSetElement.setCustomValidity(errorsText);
            if (formItem) {
                if (isValid)
                    formItem.addClass(FormGS.TagClassValid);
                else {
                    formItem.addClass(FormGS.TagClassInvalid);
                    //Находим если есть контейнер для ошибок и выводим туда сообщение
                    const invalidWr = formItem.q('.invalid-feedback').first;
                    if (invalidWr && errorsText) {
                        invalidWr.text = errorsText;
                        invalidWr.show();
                    }
                }
            }
            return isValid;
        });
    }
    addEventHandler() {
        this.q('input, textarea').forEach(i => { this.linkControl(i); });
        this.q("[name]").forEach(i => { this.linkControl(i); });
    }
    linkControl(wr) {
        //check exists
        if (this._handlers.filter(l => l.wrapper === wr).length > 0)
            return;
        const handler = (e) => {
            const wr = gs.w(e.target);
            if (wr)
                this.validFieldAsync(wr);
        };
        this._handlers.push(new core_1.EventGSHandlerDisposable(wr, "input", handler));
    }
}
exports.FormGS = FormGS;
FormGS.TagClassName = 'gs-form';
/**На данный блок накладывается is-valid is-invalid. Ищется он подъемом вверх по родителям от input*/
FormGS.TagClassItemName = 'gs-form_item';
FormGS._ExternalFunc = new Map();
FormGS.TagClassValid = 'is-valid';
FormGS.TagClassInvalid = 'is-invalid';
gs.WrapperGS.ExtendComponentsByTagClass(FormGS);
gs.WrapperGS.ExtendComponentsByHTMLElement(FormGS);
//# sourceMappingURL=FormGS.js.map